import type { Component } from 'vue'
import ButtonCompat from './button'
import PopupCompat from './popup'
import RadioCompat from './radio'
import FieldCompat from './field'
import CheckboxCompat from './checkbox'
export { ButtonCompat, PopupCompat, RadioCompat, FieldCompat, CheckboxCompat }

const compatComponents = {
  Popup: PopupCompat,
  Button: ButtonCompat,
  Radio: RadioCompat,
  Field: FieldCompat,
  Checkbox: CheckboxCompat,
} as const satisfies Record<string, Component>

export const compatAliases: Record<string, Component> = Object.fromEntries(
  Object.entries(compatComponents).map(([name, component]) => [`Van${name}`, component])
)
